import { RequestService } from '../../../../common/services/RequestService';
import { DELETE_TEMPLATE } from '../constants';

export const deleteTemplateRequest = async (profileId, templateId) => {
  const response = await RequestService.delete(
    DELETE_TEMPLATE.replace('{profile_id}', profileId).replace(
      '{offer_template_id}',
      templateId
    )
  );
  return response.data;
};
